module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (15).797f9591.jpg";